// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__xIjqU","navButton":"Navigation_navButton__LC7i4","navLink":"Navigation_navLink__7PcdX","navIcon":"Navigation_navIcon__51Nsn"};